import StickyComponent from './StickyComponent';

export default StickyComponent;
